export const FLOW_STATUS = {
  waitDispatch: 0, // 等待调度完成
  waitQC: 1, // 等待质控完成
  done: 2, // 已完成
};

export const SUBMIT_STATUS = {
  unsubmit: 1,
  done: 2,
};

export const STEP = {
  none: -1,
  one: 0, // 低错
  two: 1, // 术语
  three: 2, // 高频词
  four: 3, // 高相似
  five: 4, // 关键句子
};